import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CostBreakdownOverviewPage } from '@/areas/cost-breakdown/CostBreakdown/SourcingCostBreakdown/CostBreakdownOverviewPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <CostBreakdownOverviewPage {...pathParams} />;
}
